<div
  class="hidden lg:block fixed bottom-4 left-0 transition-transform duration-300 ease-in-out z-50"
  [class]="isVisible() ? 'translate-x-0' : '-translate-x-[calc(100%-2rem)]'">
  <div class="bg-accent rounded-r-lg shadow-lg overflow-hidden w-64">
    @if (isVisible()) {
      <div class="flex justify-between items-center p-3 border-b border-brand-300/20">
        <p class="text-xs text-brand-500">
          Other companies in
          <span class="font-semibold text-brand-500">{{ sector() }}</span>
        </p>
        <button
          class="text-brand-400 hover:text-brand-500 focus:outline-hidden transition-colors"
          (click)="toggleVisibility()">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              clip-rule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              fill-rule="evenodd" />
          </svg>
        </button>
      </div>
      <ul class="divide-y divide-brand-300/10 max-h-40 overflow-y-auto hide-scrollbar">
        @for (company of companiesInSector(); track company.companyTicker) {
          <li class="py-1.5 px-3">
            <a
              class="text-xs text-brand-500 hover:text-brand-700 transition-colors block"
              [routerLink]="['/companies/', company.slug]">
              {{ company.name }}
            </a>
          </li>
        }
      </ul>
    }
  </div>

  @if (!isVisible()) {
    <button
      class="absolute right-0 translate-x-[calc(100%-2rem)] bottom-0 bg-accent text-brand-500 px-2 py-3 rounded-r-lg shadow-lg transition-all flex items-center border-2 border-r-yellow-500 border-b-yellow-500 border-t-yellow-500 hover:scale-105"
      (click)="toggleVisibility()">
      <span class="[writing-mode:vertical-rl] [-text-orientation:mixed] rotate-180 text-xs tracking-wide">
        Sector:
        @defer (when sector()) {
          <span class="font-semibold text-brand-500">{{ sector() }}</span>
        } @placeholder {
          <span class="font-semibold text-brand-500">Loading...</span>
        }
      </span>
      <svg class="w-4 h-4 rotate-180" fill="currentColor" viewBox="0 0 20 20">
        <path
          clip-rule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          fill-rule="evenodd" />
      </svg>
    </button>
  }
</div>
